import { render, staticRenderFns } from "./OrderFiles.vue?vue&type=template&id=cc2938ee&scoped=true&"
import script from "./OrderFiles.vue?vue&type=script&lang=js&"
export * from "./OrderFiles.vue?vue&type=script&lang=js&"
import style0 from "./OrderFiles.vue?vue&type=style&index=0&id=cc2938ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2938ee",
  null
  
)

export default component.exports